import { BopGame } from './BopGame';

// Initialize the game
const game = new BopGame();

// Global functions for HTML onclick handlers
(window as any).addPlayer = () => game.addPlayer();
(window as any).startGame = () => game.startGame();
(window as any).pauseGame = () => game.pauseGame();
(window as any).restartGame = () => game.restartGame();
(window as any).showLobby = () => game.showLobby();
(window as any).toggleFullscreen = () => game.toggleFullscreen();
(window as any).shareHighlight = () => game.shareHighlight();